export default __webpack_public_path__ + "static/media/quality_focused_approach_1.11e1ab3e.png";